<template lang="pug">
  b-modal#settlementBulk(
    ref="settlementBulk"
    :title="$t('ui.settlement')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="lg"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      b-row
        b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="settleList" :fields="fields" :filter="filter")
          template(v-slot:cell(index)="row")
            span {{ row.index + 1 }}
          template(v-slot:cell(account_id)="row")
            span {{ row.item.account_id.toUpperCase() }}
          template(v-slot:cell(yesterday_balance)="row")
            span(:class="$helpers.getNumberClass(row.item.yesterday_balance)") #[b {{ row.item.yesterday_balance | currency }} ]
          template(v-slot:cell(actual_yesterday_balance)="row")
            span(:class="$helpers.getNumberClass(row.item.actual_yesterday_balance)") #[b {{ row.item.actual_yesterday_balance }} ]
          template(v-slot:cell(settle_amount)="row")
            span(:class="$helpers.getNumberClass(row.item.settle_amount)") #[b {{ row.item.settle_amount }} ]
      b-row
        b-col
          b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$tc('ui.pay', 1)" isModal=true)
</template>

<script>
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    settleList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading: false,
      filter: null,
      sortBy: "account_id",
      sortDesc: true,
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.account_id"),
          class: "align-middle text-left",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "35%"
          }
        },
        {
          key: "yesterday_balance",
          label: this.$t("ui.yesterday_balance"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "30%"
          }
        },
        {
          key: "actual_yesterday_balance",
          label: this.$t("ui.actual_yesterday_balance"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "30%"
          }
        },
        {
          key: "settle_amount",
          label: this.$t("ui.settle_amount"),
          class: "align-middle text-right",
          thClass: "align-middle text-white bg-dark-lighter",
          thStyle: {
            width: "30%"
          }
        }
      ]
    }
  },
  mounted: function() {},
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.settlement_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.settlement()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.settlement_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    settlement: function() {
      let url = (this.$store.getters.accountType == 2) ? "user/settlementMemberBulk" : "user/settlementAgentBulk"
      let list = this.settleList
      this.$store
        .dispatch(url, { list })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            let htmlContent = "<table class='table table-sm table-hover table-bordered'><tr><td>" + this.$t("ui.account_id") + "</td><td>" + this.$t("ui.status") + "</td></tr>"
            let css = "text-primary"
            response.data.forEach(value => {
              htmlContent += "<tr><td>" + value.SyncRoot[0] + "</td>"
              css = (value.SyncRoot[2].toUpperCase() == 'OK') ? "text-primary" : "text-danger"
              htmlContent += "<td><span class=" + css + ">" + this.$t("message." + value.SyncRoot[2]) + "</span></td></tr>"
            })
            htmlContent += "</table>"

            this.$swal({
              title: this.$t("ui.completed"),
              html: htmlContent,
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.loading = false
      this.submission.success = true
      this.submission.status = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    cancel: function() {
      this.$emit("clicked")
      this.$refs.settlementBulk.hide()
    }
  }
}
</script>